import { render } from "./DataCooperation.vue?vue&type=template&id=2fcb57ae&scoped=true"
import script from "./DataCooperation.vue?vue&type=script&lang=js"
export * from "./DataCooperation.vue?vue&type=script&lang=js"

import "./DataCooperation.vue?vue&type=style&index=0&id=2fcb57ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcb57ae"]])

export default __exports__